export const finalConfig = {
  esEndpoint: "https://zenmarrow.com/es"
}
